import script from "./kitchenPrepar.vue?vue&type=script&setup=true&lang=js"
export * from "./kitchenPrepar.vue?vue&type=script&setup=true&lang=js"

import "./kitchenPrepar.vue?vue&type=style&index=0&id=7a5074fc&lang=scss&scoped=true"

import exportComponent from "F:\\work\\git\\yunchi\\yc-vue-source\\yunman\\node_modules\\.store\\vue-loader@16.8.3\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7a5074fc"]])

export default __exports__